import request from '@/utils/request'
import URL from './urlTranslator'

// OCR模板查询
export function getOcrTemplateList(params) {
  return request({
    url: URL.sys.getOcrTemplateList,
    method: 'get',
    params
  })
}

// OCR模板保存
export function saveOcrTemplate(data) {
  return request({
    url: URL.sys.saveOcrTemplate,
    method: 'post',
    data
  })
}

// OCR提示词解析
export function ocrAnalyseByPromptFunc(data) {
  return request({
    url: URL.sys.ocrAnalyseByPromptUrl,
    method: 'post',
    data
  })
}

// OCR模板删除
export function deleteOcrTemplate(data) {
  return request({
    url: URL.sys.deleteOcrTemplate,
    method: 'post',
    data
  })
}

// 提示词查询
export function getOcrTemplatePromptWord(params) {
  return request({
    url: URL.sys.getOcrTemplatePromptWord,
    method: 'get',
    params
  })
}

// OCR模板字段查询
export function getOcrTemplateFieldList(params) {
  return request({
    url: URL.sys.getOcrTemplateFieldList,
    method: 'get',
    params
  })
}

// OCR模板字段保存
export function saveOcrTemplateField(data) {
  return request({
    url: URL.sys.saveOcrTemplateField,
    method: 'post',
    data
  })
}

// OCR模板字段删除
export function deleteOcrTemplateField(data) {
  return request({
    url: URL.sys.deleteOcrTemplateField,
    method: 'post',
    data
  })
}

// 禁用启用
export function activeOcrTemplate(data) {
  return request({
    url: URL.sys.activeOcrTemplate,
    method: 'post',
    data
  })
}

// 删除
export function deleteTemplateFunc(data) {
  return request({
    url: URL.sys.deleteTemplateUrl,
    method: 'post',
    data
  })
}

// 复制
export function copyOcrTemplate(params) {
  return request({
    url: URL.sys.copyOcrTemplate,
    method: 'post',
    params
  })
}

// OCR模板使用统计列表
export function getStatisticsList(params) {
  return request({
    url: URL.sys.getStatisticsList,
    method: 'get',
    params
  })
}

// OCR模板使用统计详情
export function getStatisticsDetail(data) {
  return request({
    url: URL.sys.getStatisticsDetail,
    method: 'post',
    data
  })
}
